
// students
export const GET_STUDENTS = "/students";
export const ADD_NEW_STUDENT = "/students";
export const UPDATE_STUDENT = "/students";
export const DELETE_STUDENT = "/students";
export const GET_STUDENT_BY_UUID = "/students";


